module.exports = __webpack_public_path__ + "3f2f189ba2ecd4eace55979c9fd9c55e.pdf";